import React from 'react';
import { ViewButton } from '../../Common/DataTable/tableActionButtons';
import {
  getFilter,
  getLabel,
  getSort,
} from '../../Common/DataTable/tableHelpers';
import moment from 'moment';

const createTableColumns = (
  monetizationOrders,
  customers,
  isAdmin,
  t,
  openViewModal,
  isAgency = false,
) => {
  const actions = isAdmin
    ? {
        title: 'Action',
        name: 'action',
        width: 80,
        align: 'center',
        formatterComponent: ({ row }) => (
          <ul className="list-inline font-size-20 contact-links mb-0">
            <ViewButton row={row} onPress={openViewModal} />
          </ul>
        ),
        filter: 'disabled',
        sorting: 'disabled',
      }
    : {
        title: 'Action',
        name: 'action',
        hidden: true,
        filter: 'disabled',
        sorting: 'disabled',
      };

  const adminColumns = isAdmin
    ? [
        {
          title: 'Qualified Costs',
          name: 'positiveQualifiedCosts',
          formatterComponent: ({ value }) =>
            `€ ${isFinite(value) ? value.toFixed(2) : 0}`,
          sort: true,
        },
        {
          title: 'Acquisition Costs',
          name: 'acquisitionCosts',
          formatterComponent: ({ value }) =>
            `€ ${isFinite(value) ? value.toFixed(2) : 0}`,
          sort: true,
        },
        {
          title: 'Customer',
          name: 'customerId',
          width: 180,
          formatterComponent: ({ value }) => getLabel(value, customers),
          sorting: (a, b) =>
            getSort(getLabel(a, customers), getLabel(b, customers)),
          filter: (value, filter) =>
            getFilter(getLabel(value, customers), filter.value),
        },
        {
          title: 'Sale Costs',
          name: 'totalSupplierCosts',
          formatterComponent: ({ value }) =>
            `€ ${isFinite(value) ? value.toFixed(2) : 0}`,
        },
        {
          title: 'Total Costs',
          name: 'totalCosts',
          formatterComponent: ({ value }) =>
            `€ ${isFinite(value) ? value.toFixed(2) : 0}`,
        },
        {
          title: 'Margin',
          name: 'margin',
          formatterComponent: ({ value }) =>
            `€ ${isFinite(value) ? value.toFixed(2) : 0}`,
        },
      ]
    : [];

  return [
    {
      title: 'Monetization Order',
      name: 'monetizationOrderId',
      width: isAdmin ? 180 : 250,
      formatterComponent: ({ value }) => getLabel(value, monetizationOrders),
      sorting: (a, b) =>
        getSort(
          getLabel(a, monetizationOrders),
          getLabel(b, monetizationOrders),
        ),
      filter: (value, filter) =>
        getFilter(getLabel(value, monetizationOrders), filter.value),
    },
    {
      title: 'Day',
      name: 'date',
      width: isAdmin ? 120 : 200,
      formatterComponent: ({ value }) =>
        moment(value).format('dddd, DD/MM/YYYY'),
      sorting: (a, b) => getSort(moment(a).valueOf(), moment(b).valueOf()),
      filter: (value, filter) =>
        getFilter(moment(value).format('dddd, DD/MM/YYYY'), filter.value),
    },
    {
      title: 'Incomings',
      name: 'leads',
    },
    {
      title: 'Positive',
      name: 'positives',
    },
    {
      title: 'Refused',
      name: 'refused',
    },
    {
      title: isAdmin ? 'Revenues' : isAgency ? 'Billing' : 'Costs',
      name: 'revenues',
      formatterComponent: ({ value }) =>
        `€ ${isFinite(value) ? value.toFixed(2) : 0}`,
    },
    {
      title: 'Rebates',
      name: 'rebateCosts',
      formatterComponent: ({ value }) =>
        `€ ${isFinite(value) ? value.toFixed(2) : 0}`,
    },
    ...adminColumns,
    actions,
  ];
};

export default createTableColumns;
